import * as React from "react"

const VisibilitySVG = (props) => (
	<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_7331_41792)">
			<path
				d="M13.2006 14.8416C12.091 14.8416 11.0064 14.5714 10.0838 14.0653C9.16124 13.5592 8.4422 12.8399 8.01759 11.9982C7.59298 11.1566 7.48188 10.2305 7.69835 9.33699C7.91481 8.44351 8.44911 7.6228 9.23368 6.97864C10.0183 6.33448 11.0179 5.8958 12.1061 5.71807C13.1943 5.54035 14.3223 5.63157 15.3474 5.98018C16.3725 6.3288 17.2487 6.91916 17.8651 7.67662C18.4815 8.43407 18.8106 9.3246 18.8106 10.2356C18.8106 11.4572 18.2195 12.6287 17.1674 13.4925C16.1153 14.3563 14.6884 14.8416 13.2006 14.8416ZM13.2006 3.07068C4.47389 3.07068 0.733887 10.2356 0.733887 10.2356C0.733887 10.2356 4.47389 17.4005 13.2006 17.4005C21.9272 17.4005 25.6672 10.2356 25.6672 10.2356C25.6672 10.2356 21.9272 3.07068 13.2006 3.07068Z"
				fill="#2C3533"
				fill-opacity="0.4"
			/>
			<path
				d="M13.2007 12.7944C14.9219 12.7944 16.3173 11.6488 16.3173 10.2355C16.3173 8.82229 14.9219 7.67664 13.2007 7.67664C11.4794 7.67664 10.084 8.82229 10.084 10.2355C10.084 11.6488 11.4794 12.7944 13.2007 12.7944Z"
				fill="#2C3533"
				fill-opacity="0.4"
			/>
		</g>
		<defs>
			<clipPath id="clip0_7331_41792">
				<rect width="24.9333" height="20.4711" fill="white" transform="translate(0.733887)" />
			</clipPath>
		</defs>
	</svg>
)

export default VisibilitySVG
